import React, { useContext } from 'react'
import { Container, Title } from '@provi/provi-components'
import { TemplateContext } from '../../../components/template/context'
import { TemplateForm } from '../../../components/template-form'
import { FormFomik } from './form'

export const IntendedWayToExpend = () => {
  const { goToNextScreen, creditPath } = useContext(TemplateContext)
  return (
    <TemplateForm>
      <Container>
        <Title text="O que pretende fazer com o dinheiro que receber?" />
        <FormFomik data={creditPath && creditPath.ReadResourcesPurpose} goToNextScreen={goToNextScreen} />
      </Container>
    </TemplateForm>
  )
}
